export default __webpack_public_path__ + "static/media/chair.78391c44.png";